module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": _vm.errorMessage
    }
  }) : [(_vm.isOpen) ? _c('MentoringMeeting', {
    attrs: {
      "meeting": _vm.meeting,
      "meetingNumber": _vm.index
    },
    on: {
      "close": function($event) {
        return _vm.$emit('closeMeetingPopup')
      }
    }
  }) : _c('MentoringProgramForm', {
    attrs: {
      "meetingNumber": _vm.index
    },
    on: {
      "submitMeetingForm": _vm.submitMeetingForm
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ca8c29c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/modal/MentoringModal.vue
// module id = 2d1f7aae064a321b5cdc
// module chunks = 89